// extracted by mini-css-extract-plugin
export default {"getstartedscreen":"a128a6a9a17d91de5083","header":"eb108cd916f342c980a5","main":"ed0c4836b99dc02e3c6f","sidebar":"f06a1e1d8b840d20e626"};